import useAuth from '../../auth/UseAuth';
import { useEffect, useState } from 'react';
import { orderBy } from 'lodash';
import { GetEntities, SuperDuperFiestaEntity } from '../../data/SuperDuperFiestaData';

const useSuperDuperFiestaEntities = (): ReadonlyArray<SuperDuperFiestaEntity> => {
  const { accessToken } = useAuth();
  const [SuperDuperFiestaEntities, setSuperDuperFiestaEntities] = useState<ReadonlyArray<SuperDuperFiestaEntity>>([]);

  useEffect(() => {
    let isCancelled = false;

    GetEntities(accessToken).then(data => {
      if (isCancelled) {
        return;
      }

      setSuperDuperFiestaEntities(orderBy(data, i => i.name));
    });

    return () => {
      isCancelled = true;
    };
  }, [accessToken]);

  return SuperDuperFiestaEntities;
};

export default useSuperDuperFiestaEntities;
